import {QuoteWizardNavigationService} from '../../../quoteWizardNavigation.service';
import {QuoteWizardStateService} from '../../../quoteWizardState.service';
import {ScreenLockService} from "../../../../core/services/screenLockService/screenLock.service";

export class SubmitRequestController {
    public quoteWizardForm: ng.IFormController;

    public static $inject = ['quoteWizardNavigationService', 'quoteWizardStateService', '$q', 'screenLockService'];

    constructor(private navigationService: QuoteWizardNavigationService,
         private stateService: QuoteWizardStateService,
          private $q: ng.IQService,
          private screenLockService: ScreenLockService) {
    }

    public goNext(): void {
        this.screenLockService.broadcast(1);
        this.stateService.saveAndQuoteSubmissionRequest()
           .then(() => {
                this.navigationService.goNext();
            });
    }

    public goBack(): void {
        this.navigationService.goBack();
    }
}